import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import FeaturesService from 'ember-feature-flags/services/features';
import WorkspaceSettingsMergeOptionsController from './controller';

export default class WorkspaceSettingsMergeOptions extends Route {
  @service environment!: EnvironmentService;
  @service features!: FeaturesService;

  crumb() {
    return {
      name: 'Merge Options',
      path: 'merge_options',
    };
  }

  setupController(controller: WorkspaceSettingsMergeOptionsController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.autoMergePanelExpanded = false;
  }
}
